<ng-container *ngIf="loaded">
  <div class="items-wrapper">
    <div class="items-header">
      <!-- Category -->
      <div class="header category">
        <yc-i18n
          key="GLOBAL:textCategory"
          defaultValue="Category">
        </yc-i18n>
      </div>
      <!-- Items -->
      <div class="header items">
        <yc-i18n
          key="common:lblItems">
        </yc-i18n>
      </div>
      <!-- Units Header-->
      <div class="header">
        <yc-i18n
          key="common:textUnits">
        </yc-i18n>
      </div>
      <!-- Value Per Item Header -->
      <div class="header">
        <yc-i18n
          key="GLOBAL:textValuePerItem"
          defaultValue="Value per item">
        </yc-i18n>
      </div>
      <!-- Total Value Header -->
      <div class="header right">
        <yc-i18n
          key="GLOBAL:textTotalValue"
          defaultValue="Total value">
        </yc-i18n>
      </div>
      <!-- Actions -->
      <div class="action"></div>
    </div>
    
    <!-- Items List -->
    <cdk-virtual-scroll-viewport itemSize="30"
      [ngStyle]="{
        'height': repository.currentSet.length >= 2 ?
          '175px' :
          '100px'
      }">
      <ng-container 
        *cdkVirtualFor="let item of repository.currentSet; let index = index; let last = last; trackBy: trackBy;">
        <div class="items-list">
          <div class="items-row"
            [class.padding-2rem]="errorMap[item.identification]">
            <div *ngIf="addingItem ?
              index !== 0 :
              true"
              class="row-area category">
              {{ categoriesNameMap[item.categoryId] }}
            </div>
            <div *ngIf="addingItem && index === 0"
              class="row-area category">
              <yc-typeahead-select
                [items]="categoryOptions"
                [placeholder]="categoryPlaceholder"
                [(value)]="selectedCategory"
                [showClear]="false"
                (valueChange)="categoryChange($event)">
              </yc-typeahead-select>
            </div>
            
            <!-- Items -->
            <div class="row-area text items">
              <ng-container *ngIf="addingItem ?
                index !== 0 :
                true">
                {{ item.name }}
                <small class="d-block">
                  <!-- Item no longer in use -->
                  <yc-i18n *ngIf="!item.inUse"
                    key="BUDGET:textItemNoLongerActive"
                    defaultValue="Item no longer active"
                    class="text-danger">
                  </yc-i18n>
                  <!-- Item in use -->
                  <ng-container *ngIf="item.inUse">    
                    <!-- Number Remaining --> 
                    <yc-i18n *ngIf="isAward || awardAndPaymentSame"
                      key="BUDGET:textNumberUnitsRemaining"
                      [context]="{
                        number: (item.unitsRemaining - +item.unitsEntered) < 0 ?
                          0 :
                          (item.unitsRemaining - +item.unitsEntered)
                      }"
                      defaultValue="__number__ units remaining">
                    </yc-i18n>
                    <!-- Number to Pay -->
                    <yc-i18n *ngIf="!isAward && !awardAndPaymentSame"
                      key="BUDGET:textNumberUnitsToPay"
                      [context]="{
                        number: itemsToPayMap[item.identification] || 0
                      }"
                      defaultValue="__number__ to pay">
                    </yc-i18n>
                  </ng-container>
                </small>
              </ng-container>
              <ng-container *ngIf="addingItem && index === 0">
                <yc-typeahead-select
                  [(value)]="item.identification"
                  [items]="availableItems"
                  [label]="'common:textSelectAnItem' | ycI18n: 'Select an item'"
                  [srOnlyLabel]="true"
                  [notFoundText]="noItemsFoundText"
                  [placeholder]="'common:textSelectAnItem' | ycI18n: 'Select an item'"
                  (onChange)="itemSelected(item, $event)">
                </yc-typeahead-select>
              </ng-container>
            </div>
            <!-- Units -->
            <div class="row-area">
              <ng-container *ngIf="addingItem ?
                ((index === 0) && item.identification) :
                editingIndex === index">
                <yc-input
                  [(value)]="item.unitsEntered"
                  [isNumber]="true"
                  [min]="0"
                  [label]="'common:textUnits' | ycI18n: 'Units'"
                  [srOnlyLabel]="true"
                  [numberOfDecimals]="0"
                  [customError]="errorMap[item.identification]"
                  (onChange)="onItemsEntered(item, $event)">
                </yc-input>
              </ng-container>
              <ng-container *ngIf="editingIndex !== index">
                {{ item.unitsEntered }}
              </ng-container>
            </div>
            <!-- Value Per Item  -->
            <div class="row-area">
              <ng-container *ngIf="item.identification">
                {{ item.value | gcMoney }}
              </ng-container>
            </div>
            <!-- Total Value  -->
            <div class="row-area">
              <ng-container *ngIf="item.identification">
                {{ totalMap[item.identification] | gcMoney }}
              </ng-container>
            </div>

            <div *ngIf="!disabled"
              class="row-area right d-flex">
              <!-- Remove Row -->
                <yc-button *ngIf="addingItem ? index === 0 : !isEditing"
                  [icon]="true"
                  [tooltipText]="!(
                    item.identification | gcCanRemoveInKindItem:
                      isAward:
                      paidItems:
                      alreadyPaidItems:
                      awardAndPaymentSame
                    ) ?
                    ('AWARDS:textDisabledDeleteItemTooltip' | ycI18n: 'Unable to delete item existing on a payment.') :
                    ''"
                  placement="top"
                  [disabled]="!(
                    item.identification | gcCanRemoveInKindItem:
                      isAward:
                      paidItems:
                      alreadyPaidItems:
                      awardAndPaymentSame
                    )"
                  [value]="'common:textRemove' | ycI18n: 'Remove'"
                  (onClick)="removeRow(item, index)">
                  <yc-fa
                    icon="times"
                    [light]="true"
                    class="text-danger">
                  </yc-fa>
                </yc-button>
              <!-- Edit Row -->
              <yc-button *ngIf="!addingItem &&
                !isEditing"
                [icon]="true"
                [value]="'common:textEdit' | ycI18n: 'Edit'"
                (onClick)="editingIndex = index; onEditChange.emit(isEditing)">
                <yc-fa
                  icon="pencil"
                  [light]="true"
                  class="text-link">
                </yc-fa>
              </yc-button>
              <!-- Save Row -->
              <yc-button *ngIf="!errorMap[item.identification] &&
                (addingItem ?
                  ((index === 0) && item.identification) :
                  editingIndex === index)"
                [icon]="true"
                [value]="'common:btnSave' | ycI18n: 'Save'"
                (onClick)="saveRow(item)">
                <yc-fa
                  icon="check"
                  [light]="true"
                  class="text-success">
                </yc-fa>
              </yc-button>
            </div>
          </div>
        </div>
      </ng-container>
    </cdk-virtual-scroll-viewport>


    <!-- Add an Item -->
    <yc-button *ngIf="!disabled && !addingItem && !isEditing"
      class="ms-3 mt-2"
      [link]="true"
      [value]="'GLOBAL:textAddAnItem' | ycI18n: 'Add an item'"
      (onClick)="addAnItem()">
      <yc-fa
        [light]="true"
        icon="plus"
        class="me-2">
      </yc-fa>
      <yc-i18n *ngIf="awardAndPaymentSame"
        key="GLOBAL:textAddAnItem"
        defaultValue="Add an item">
      </yc-i18n>
      <yc-i18n *ngIf="isAward && !awardAndPaymentSame"
        key="AWARDS:textAddAnItemToAward"
        defaultValue="Add an item to award">
      </yc-i18n>
      <yc-i18n *ngIf="!isAward && !awardAndPaymentSame"
        key="AWARDS:textAddAnItemToPayment"
        defaultValue="Add an item to payment">
      </yc-i18n>
    </yc-button>

    <!-- Totals -->
    <div class="totals-line">
      <!-- Total Selected -->
      <div class="total add-item"></div>
      <!-- Total Units -->
      <div class="total total-units">
        <yc-i18n
          key="GLOBAL:textNumberUnits"
          [context]="{
            number: totalUnits | number
          }"
          defaultValue="__number__ units">
        </yc-i18n>
      </div>
      <!-- Total Value -->
      <div class="total total-value">
        {{ totalText }}: 
        {{ totalValue | gcMoney }}
      </div>
    </div>
  </div>
</ng-container>
